/**
 * @Author : zhouqinze
 * @Date : 2019-12-29
 * @Version : 1.0
 * @Content : 员工关怀
 **/
<template>
    <div>
        <div class="aboutComHead">
            <p>员工关怀</p>
            <p><span></span><span></span></p>
        </div>
        <div class="careCon">
            <div class="careBox" v-for="(item,index) in thisArr" :key="index" :style="{background:'url('+item.img+') no-repeat 45px center'}">
                <h3 v-text="item.title"></h3>
                <p v-text="item.text"></p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            thisArr:[
                {
                    title:'健全的福利制度：',
                    text:'全员缴纳社保（5险）、住房公积金（含试用期）',
                    img:'http://comit.oss-cn-hangzhou.aliyuncs.com/img/icon_flzd.png'
                },
                {
                    title:'完善的员工假期：',
                    text:'国家法定节假日、带薪年假、超长春节假期、病假、产假、婚假、丧假等。',
                    img:'http://comit.oss-cn-hangzhou.aliyuncs.com/img/icon_jq.png'
                },
                {
                    title:'人性化的弹性福利：',
                    text:'提供餐补、每周下午茶福利、出差补贴、通讯补贴、中秋节日礼品及年度体检等。',
                    img:'http://comit.oss-cn-hangzhou.aliyuncs.com/img/icon_txfl.png'
                },
            ]
        }
    },
}
</script>

<style lang="scss" scoped>
    .aboutComHead{
        width: 5.875rem;
        font-size: 1.4375rem;
        color: #333;
        margin-bottom: .75rem;
        font-weight: bold;
        margin-bottom: 1.25rem;
        span{
            display: inline-block;
            width: 50%;
            height: .1875rem;
            background: #018CF4;
        }
        span:last-child{
            background: #ddd;
        }
    }
    .careCon{
        .careBox{
            width: 100%;
            height: 7.25rem;
            padding: 1.875rem 1.75rem;
            box-sizing: border-box;
            margin-bottom: 1.875rem;
            box-shadow: 0 0 .625rem #ddd;
            text-align: start;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            h3{
                margin-left: 6.875rem;
                font-size: 1rem;
                line-height: 1rem;
                margin-bottom: 1.125rem;
                text-align: start;
            }
            p{
                margin-left: 6.875rem;
                font-size: .8125rem;
                line-height: .8125rem;
                color: #666;
                text-align: start;
            }
        }
    }
</style>